import {
  Button, Card,
  CardContent, CardHeader,
  Divider,
  Grid,
  Dialog, DialogActions, DialogContent, DialogTitle, IconButton,
  TextField, Typography, InputAdornment, Box, Paper,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import CropFreeIcon from '@material-ui/icons/CropFree';

import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import FingerprintIcon from '@material-ui/icons/Fingerprint';
import ReceiptIcon from '@material-ui/icons/Receipt';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import SearchIcon from '@material-ui/icons/Search';
import SendIcon from '@material-ui/icons/Send';
import ComputerIcon from '@material-ui/icons/Computer';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import BarkodPopup from '../../components/BarcodePopup';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    borderRadius: '12px',
    boxShadow: '0 8px 16px rgba(0,0,0,0.1)'
  },
  content: {
    minHeight: 430,
    padding: theme.spacing(3)
  },
  infoBox: {
    padding: theme.spacing(2),
    borderRadius: '8px',
    backgroundColor: '#fff',
    border: '1px solid #e0e0e0',
    borderTop: '4px solid #FF9800',
    height: '100%',
    transition: 'all 0.3s ease'
  },
  label: {
    color: '#424242',
    fontWeight: 600,
    fontSize: '0.75rem',
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(0.5)
  },
  value: {
    color: '#212121',
    fontWeight: 700,
    fontSize: '1rem'
  },
  // Parametreler için yeni tablo stili
  paramContainer: {
    marginTop: theme.spacing(2),
    backgroundColor: '#fafafa',
    borderRadius: '8px',
    border: '1px solid #eee',
    overflow: 'hidden'
  },
  tableHeader: {
    backgroundColor: '#424242',
    '& th': {
      color: '#ffffff',
      fontWeight: 'bold',
      fontSize: '0.75rem',
      borderBottom: 'none'
    }
  },
  tableRow: {
    '&:nth-of-type(even)': {
      backgroundColor: '#f5f5f5',
    },
    '& td': {
      fontSize: '0.85rem',
      fontWeight: 500,
      color: '#333'
    }
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%',
    padding: theme.spacing(1.5),
    fontWeight: 'bold',
    borderRadius: '8px'
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: '#FF9800',
      },
    },
    '& .MuiInputLabel-outlined.Mui-focused': {
      color: '#FF9800',
    },
  },
  table: {
    tableLayout: 'fixed', // Sütun genişliklerini sabitlemek için ŞART
    width: '100%',
  },
  breakWord: {
    wordBreak: 'break-all', // Kelimeyi (sayıları) her yerden böler
    overflowWrap: 'anywhere', // Uzun stringleri her koşulda alt satıra atar
    fontSize: '0.1rem', // Çok uzunsa okunabilirliği bozmadan küçültmek iyidir
  }
}));

function Urun({ className, FisNo, readonly, tasks }) {
  const classes = useStyles();

  const [formOpen, setFormOpen] = useState(false);
  const [openBarkod, setOpenBarkod] = useState(false);
  const [passKey, setPassKey] = useState('');
  const [eskiImei, setEskiImei] = useState('');
  const [eskiImeiErrorText, setEskiImeiErrorText] = useState('');
  const [yeniImeiErrorText, setYeniImeiErrorText] = useState('');
  const [imsiErrorText, setImsiErrorText] = useState('');
  const [imsi, setImsi] = useState('');
  const [yeniImei, setYeniImei] = useState('');
  const [alertVal, setAlertVal] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertType, setAlertType] = useState('success');
  const OkcModel = ['TQC000', 'WVJ000', 'BQ1T00', 'BQ2T00'];

  const openAlertMessage = (text, messageType) => {
    setAlertMessage(text);
    setAlertVal(true);
    setAlertType(messageType);
  };

  const OkcData = readonly
    ? (Array.isArray(tasks?.tasks) ? tasks.tasks.filter((d) => parseInt(d.FisNo, 10) === parseInt(FisNo, 10)) : [])
    : (loadBaslandiJob() || []);

  useEffect(() => {
    const data = OkcData?.[0];
    setEskiImei(data?.EskiImei || '');
    setYeniImei(data?.YeniImei || '');
    setImsi(data?.Imsi || '');
  }, [OkcData]);

  // Fonksiyonlar (Eski Imei, Yeni Imei, Imsi, GetPassword, GetNace, Barkod işlemleri eksiksiz buradadır)
  const handleBarkodOpen = () => { if (!readonly) setOpenBarkod(true); };
  const handleBarkodClose = async (barkod) => {
    setOpenBarkod(false);

    // 1. Önce readonly kontrolü
    if (readonly) return;

    // 2. barkod'un string olup olmadığını ve içeriğini kontrol et
    if (typeof barkod !== 'string' || !barkod.includes(':')) {
      return;
    }

    // 3. Güvenli şekilde split yap
    const parts = barkod.split(':');
    if (parts[1]) {
      setPassKey(parts[1]);
    }





  };

  const validImei = (value) => /(35([0-9]{13}))$/.test(value);
  const validImsi = (value) => /(89([0-9]{16,18}))$/.test(value);

  const handleChangeEskiImei = (event) => {
    if (readonly) return;
    let job = (loadBaslandiJob() || [])[0];
    if (!job) return;
    setEskiImei(event.target.value);
    job = { ...job, EskiImei: event.target.value };
    saveBaslandiJob(job);
    setEskiImeiErrorText(!validImei(event.target.value) ? 'Imei 35 ile başlayan 15 hane olmalı.' : '');
  };

  const handleChangeYeniImei = (event) => {
    if (readonly) return;
    let job = (loadBaslandiJob() || [])[0];
    if (!job) return;
    setYeniImei(event.target.value);
    job = { ...job, YeniImei: event.target.value };
    saveBaslandiJob(job);
    setYeniImeiErrorText(!validImei(event.target.value) ? 'Imei 35 ile başlayan 15 hane olmalı.' : '');
  };

  const handleChangeImsi = (event) => {
    if (readonly) return;
    let job = (loadBaslandiJob() || [])[0];
    if (!job) return;
    setImsi(event.target.value);
    job = { ...job, Imsi: event.target.value };
    saveBaslandiJob(job);
    setImsiErrorText(!validImsi(event.target.value) ? 'Imsi 89 ile başlayan 18-20 hane olmalı.' : '');
  };

  const getPassword = () => {
    const jobs = loadBaslandiJob() || [];
    if (!jobs[0]) return;
    if (jobs[0]?.BARKOD !== jobs[0]?.OkcBarkod) {
      openAlertMessage("Lütfen doğru maliID'ye ait barkodu okutunuz", 'error');
      return;
    }
    if ((OkcModel.includes(OkcData?.[0]?.KUL_MODEL_KODU)) && !formOpen) {
      setFormOpen(true);
      return;
    }
    axios.get(`/GetArtemisOkcPassword/${OkcData?.[0]?.BIRIM_KODU}/${OkcData?.[0]?.FisNo}/${OkcData?.[0]?.TEKNISYEN_KODU}`).then((response) => {
      if (response.data.ErrorCode === '0') {
        let job = (loadBaslandiJob() || [])[0];
        if (!job) return;
        job = { ...job, OkcSifre: response.data.ErrorDescription };
        saveBaslandiJob(job);
        openAlertMessage(response.data.ErrorDescription, 'success');
      } else {
        openAlertMessage(response.data.ErrorDescription, 'error');
      }
    });
  };

  const getPasswordEncrypted = () => {
    setFormOpen(false);
    axios.get(`/GetArtemisOkcPasswordEncrypted/${OkcData?.[0]?.BIRIM_KODU}/${OkcData?.[0]?.FisNo}/${OkcData?.[0]?.TEKNISYEN_KODU}/${OkcData?.[0]?.MaliId}/${passKey || 'A'}`).then((response) => {
      if (response.data.ErrorCode === '0') {
        let job = (loadBaslandiJob() || [])[0];
        if (!job) return;
        job = { ...job, OkcSifre: response.data.ErrorDescription };
        saveBaslandiJob(job);
        openAlertMessage(response.data.ErrorDescription, 'success');
      } else {
        openAlertMessage(response.data.ErrorDescription, 'error');
      }
    });
  };

  const getNaceKdv = () => {
    var job = (loadBaslandiJob() || [])[0];
    if (!job) return;
    window.open(`https://tbs.tokeninc.com/portal/technicianHelper?FiscalId=${job?.MaliId}&TaxId=${job?.UDS_VERGI_NUMARASI}`);
  };

  if (!OkcData || OkcData?.length === 0) return null;

  return (
    <div>
      <Card className={clsx(classes.root, className)}>
        <CardHeader title="Okc Detay" />
        <Divider />
        <CardContent className={classes.content}>

          {/* ÜST BİLGİ KUTULARI */}
          <Grid container spacing={2} style={{ marginBottom: 24 }}>
            <Grid item xs={12} md={4}>
              <Paper className={classes.infoBox} elevation={0}>
                <Typography className={classes.label}><AccountBalanceIcon fontSize="inherit" style={{ marginRight: 4 }} /> Vergi Dairesi</Typography>
                <Typography className={classes.value}>{OkcData[0]?.UDS_VERGI_DAIRESI_KOD} - {OkcData[0]?.UDS_VERGI_DAIRESI}</Typography>
              </Paper>
            </Grid>
            <Grid item xs={6} md={4}>
              <Paper className={classes.infoBox} elevation={0} style={{ borderTopColor: '#424242' }}>
                <Typography className={classes.label}><ReceiptIcon fontSize="inherit" style={{ marginRight: 4 }} /> Vergi No</Typography>
                <Typography className={classes.value}>{OkcData[0]?.UDS_VERGI_NUMARASI}</Typography>
              </Paper>
            </Grid>
            <Grid item xs={6} md={4}>
              <Paper className={classes.infoBox} elevation={0} style={{ borderTopColor: '#FF9800' }}>
                <Typography className={classes.label}><FingerprintIcon fontSize="inherit" style={{ marginRight: 4 }} /> Mali ID</Typography>
                <Typography className={classes.value} style={{ color: '#FF9800' }}>{OkcData[0]?.MaliId}</Typography>
              </Paper>
            </Grid>
          </Grid>

          {/* TERMİNAL PARAMETRELERİ - MODERN TABLO TASARIMI */}
          {OkcData?.[0]?.MaliId && OkcData?.[0]?.OkcParametre && (() => {
            try {
              const params = JSON.parse(OkcData[0].OkcParametre);
              if (!Array.isArray(params)) return null;
              return (
            <Box mb={4}>
              <Typography variant="subtitle2" style={{ fontWeight: 800, color: '#424242', display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                <ComputerIcon fontSize="small" style={{ marginRight: 6, color: '#FF9800' }} /> TERMİNAL PARAMETRELERİ
              </Typography>
              <TableContainer component={Paper} elevation={0} className={classes.paramContainer}>
                <Table size="small" className={classes.table} style={{ tableLayout: 'fixed' }}>
                  <TableHead className={classes.tableHeader}>
                    <TableRow>
                      {/* Sütun oranlarını net belirleyelim */}
                      <TableCell style={{ width: '25%' }}>PARTNER</TableCell>
                      <TableCell style={{ width: '40%' }} align="center">TERMİNAL ID</TableCell>
                      <TableCell style={{ width: '35%' }} align="right">ÜYE İŞYERİ KODU</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {params.map((row, index) => (
                      <TableRow key={index} className={classes.tableRow}>
                        <TableCell className={classes.breakWord}>{row.Partner || '-'}</TableCell>
                        <TableCell className={classes.breakWord} align="center">
                          {row.terminalId || '-'}
                        </TableCell>
                        <TableCell className={classes.breakWord} align="right">
                          {row.uyeIsyeriKodu || '-'}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
              );
            } catch (e) {
              return null;
            }
          })()}

          <Divider style={{ margin: '24px 0' }} />

          {/* INPUT ALANLARI */}
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField className={classes.textField} label="Eski Imei" fullWidth variant="outlined" onChange={handleChangeEskiImei} disabled={readonly} value={eskiImei || ''} helperText={eskiImeiErrorText} InputLabelProps={{ shrink: true }} />
            </Grid>
            <Grid item xs={6}>
              <TextField className={classes.textField} label="Yeni Imei" type="number" fullWidth variant="outlined" onChange={handleChangeYeniImei} disabled={readonly} value={yeniImei} helperText={yeniImeiErrorText} InputLabelProps={{ shrink: true }} />
            </Grid>
            <Grid item xs={12}>
              <TextField className={classes.textField} label="Imsi" type="number" fullWidth variant="outlined" onChange={handleChangeImsi} disabled={readonly} value={imsi} helperText={imsiErrorText} InputLabelProps={{ shrink: true }} />
            </Grid>
          </Grid>

          {/* AKSİYON BUTONLARI */}
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Button
                variant="contained"
                color="secondary"
                className={classes.submitButton}
                onClick={getPassword}
                disabled={readonly}
                startIcon={<VpnKeyIcon />}
              >
                Okc Şİfre Getir
              </Button>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Button
                variant="contained"
                color="secondary"
                className={classes.submitButton}
                onClick={getNaceKdv}
                disabled={readonly}
                startIcon={<SearchIcon />}
              >
                Nace Kdv Sorgu
              </Button>
            </Grid>
          </Grid>

          {alertVal && <Alert onClose={() => setAlertVal(false)} open={alertVal} message={alertMessage || ''} variant={alertType} />}
        </CardContent>
      </Card>

      {/* ŞİFRE DİALOG */}
      <Dialog open={formOpen} onClose={() => setFormOpen(false)} fullWidth PaperProps={{ style: { borderRadius: 12 } }}>
        <DialogTitle style={{ backgroundColor: '#424242', color: '#fff' }}>Güvenlik Doğrulaması</DialogTitle>
        <DialogContent style={{ paddingTop: 24 }}>
          <Typography variant="body2" gutterBottom>QR üzerindeki <b>kırmızı</b> kodu giriniz:</Typography>
          <TextField
            fullWidth
            variant="outlined"
            className={classes.textField}
            value={passKey}
            onChange={(e) => setPassKey(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton color="primary" onClick={handleBarkodOpen}><CropFreeIcon /></IconButton>
                </InputAdornment>
              )
            }}
          />
          <Button variant="contained" color="secondary" fullWidth onClick={getPasswordEncrypted} style={{ marginTop: 20 }} startIcon={<SendIcon />}>
            ŞİFREYİ ONAYLA VE AL
          </Button>
        </DialogContent>
        <DialogActions><Button onClick={() => setFormOpen(false)}>Kapat</Button></DialogActions>
      </Dialog>

      <BarkodPopup onClose={handleBarkodClose} open={openBarkod} ScanTime={0} CallScreen={0} />
    </div>
  );
}

Urun.propTypes = { className: PropTypes.string, FisNo: PropTypes.string, tasks: PropTypes.object, readonly: PropTypes.bool };
export default connect((state) => ({ tasks: state.tasks1 }))(Urun);